import { useIntl } from '@leagueplatform/locales';
import { toastActions, TOAST_STATUS } from '@leagueplatform/toast-messages';
import {
  trackAnalyticsEvent,
  EVENT_NAME,
  PRODUCT_AREA,
} from '@leagueplatform/analytics';
import { useUpdateUserProfile } from './use-personal-information.hook';
import { ANALYTICS_SCREEN_NAMES } from '../common/constants';

export const useUserProfileSave = () => {
  const { formatMessage } = useIntl();
  const { updateUserProfile, isLoading } = useUpdateUserProfile();

  const handleUserProfileSave = async (inputValue: Record<string, any>) => {
    try {
      // This is a temp. workaround
      const payload = { ...inputValue };
      if (inputValue.genderIdentity) {
        payload.genderIdentity = [inputValue.genderIdentity];
      }

      await updateUserProfile(payload);
      toastActions.add({
        type: TOAST_STATUS.SUCCESS,
        textId: formatMessage({ id: 'STR_PERSONAL_INFORMATION_UPDATED' }),
      });
    } catch (err) {
      trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
        product_area: PRODUCT_AREA.SETTINGS,
        sub_product_area: ANALYTICS_SCREEN_NAMES.PERSONAL_INFO,
        screen_name: ANALYTICS_SCREEN_NAMES.ERROR_SAVING_PERSONAL_INFO,
      });
      toastActions.add({
        type: TOAST_STATUS.ERROR,
        textId: formatMessage({ id: 'STR_PERSONAL_INFORMATION_UPDATE_ERROR' }),
      });
    }
  };

  return { handleUserProfileSave, isLoading };
};
